import AbstractView from "./abstract.js";
import Slider from "./slider.js";
import {createElement, render, remove, replace} from "../utils/render.js";
import {Keys} from "../const.js";
import {catalog} from "../data/catalog.js";

const createSliderMarkup = (list) => {
  const listMap = list.map((item) => {
  const {code, images, text, logoImages, link} = item;
  const codeText = code ? `<span class="slider__item-promo-code">${code}</span>` : ``;
  const imageMarkup = link
    ? `<a class="slider__item-link" href="${link}" target="_blank" rel="noopener noreferrer">
          <img class="slider__item-image" src="${images}" alt="">
      </a>`
    : `<img class="slider__item-image" src="${images}" alt="">`;
  const logoImagesMarkup = logoImages ? `<img class="slider__logo " src="${logoImages}" alt="" height="24">` : ``;

    // console.log("item", item);
  return (
      `<li class="slider__item">
        ${logoImagesMarkup}

        ${imageMarkup}

        <p class="slider__item-description">${text}</p>
        ${codeText}
      </li>`
    );
  }).join(`\n`);

  return (`<ul class="slider__list">${listMap}</ul>`);
};

const createDotsMarkup = (list) => {
  const createDotsMarkup = list
    .map(() => {
      return (`
        <li class="slider__slide-changer-item">
          <button class="slider__slide-changer-dot" type="button" aria-label="Перейти к слайду номер 2"></button>
        </li>
      `);
    }).join(`\n`);

  return (
    `<ul class="slider__slide-changer">${createDotsMarkup}</ul>`
  );
};

const popupMarkup = (filterItem, selectedSector) => {
  const listShow = Object.values(catalog[selectedSector])
  // const listShow = Object.values(catalog[`other`])
    .filter((item) => item.filter.indexOf(filterItem) >= 0);
  const sliderMarkup = createSliderMarkup(listShow);
  const dotsMarkup = createDotsMarkup(listShow);

  return (
    `<div class="spinner__gift-slider slider slider_open content__slider_start">
      <button class="button-close slider__button-close" aria-label="Закрыть окно">
        <svg class="slider__icon-close" aria-label="Закрыть" width="13" height="13">
          <use xlink:href="#icon-close"></use>
        </svg>
      </button>

      <div class="slider__control">
        <button class="slider__slide slider__slide_prev" aria-label="Листать в начало" tabindex="-1">
          <svg class="slider__slide-icon" width="13" height="24">
            <use xlink:href="#slider-arrow"></use>
          </svg>
        </button>

        <button class="slider__slide slider__slide_next" aria-label="Листать в конец" tabindex="-1">
          <svg class="slider__slide-icon" width="13" height="24">
            <use xlink:href="#slider-arrow"></use>
          </svg>
        </button>
      </div>

      ${sliderMarkup}
      ${dotsMarkup}
    </div>`
  );
};

const Popup = class extends AbstractView {
  constructor(siteBodyElement, filterItem, selectedSector) {
    super();
    this._siteBodyElement = siteBodyElement;
    this._closePopupHandler = this._closePopupHandler.bind(this);
    this._filterItem = filterItem;
    this._selectedSector = selectedSector;
    setTimeout(() => {
      this._sliderComponent = new Slider(siteBodyElement);
    }, 1000);
  }

  init() {
  }

  getTemplate() {
    return popupMarkup(this._filterItem, this._selectedSector);
  }

  getElement() {
    if (!this._element){
      this._element = createElement(this.getTemplate());
    }

    return this._element;
  }

  removeElement() {
    this._element = null;
  }

  showSliderPopup(event) {
    event.preventDefault();
    if (this.root.classList.contains(`slider_open`)) {
      this._closeSliderPopup(event);
    } else {
      this._siteBodyElement.classList.add(`popup-open`);
      this.root.classList.add(`slider_open`);
      document.addEventListener(`keydown`, this._escKeyDownHandler);
    }
  }

  _closeSliderPopup(event) {
    event.preventDefault();
    document.removeEventListener(`keydown`, this._escKeyDownHandler);
    this._siteBodyElement.classList.remove(`popup-open`);
    this.root.classList.remove(`slider_open`);
  }

  _escKeyDownHandler(event) {
    // console.log(`close popup`);
    if (event.key === Keys.ESC || event.key === Keys.ESCAPE) {
      event.preventDefault();
      this.showSliderPopup(event);
    }
  }

  _closePopupHandler(event) {
    event.preventDefault();
    this._callback.closePopup();
  }

  setClosePopupHandler(callback) {
    this._callback.closePopup = callback;
    this.getElement().querySelector(`.slider__button-close`)
      .addEventListener(`click`, this._closePopupHandler);
  }
};

export default Popup;
